export function MobileContainer ({children})
{
    return(
        <div style={{minHeight:"100dvh", height:"100dvh", 
        width:"100dvw", minWidth:"100dvw", 
        maxHeight:"100dvwh", maxWidth:"100dvw",
        display: "flex", justifyContent:"center", 
        alignItems:"center"}}>
            {children}
        </div>
    );
}